import { names } from '@prolaera/library';

const ToCamelCase = () => {
  return function(string) {
    const tokens = string.split(' ');
    if (tokens.length === 0) {
      return '';
    }
    const firstToken = tokens[0];
    const otherTokens = tokens.slice(1);
    return '' + firstToken.toLowerCase() + otherTokens.map(_capitalizeFirstLetter).join('');
  };
};

const TitleFromCamelCase = () => {
  return function(camelCase) {
    const tempName = camelCase.toLowerCase();
    if (names[tempName]) return names[tempName];

    return camelCase
      .replace(/([A-Z]+)/g, ' $1')
      .replace(/^./, function(str) {
        return str.toUpperCase();
      })
      .trim();
  };
};

function CapitalizeFirstLetter() {
  return _capitalizeFirstLetter;
}

function _capitalizeFirstLetter(str) {
  if (!str || str.length === 0) {
    return '';
  }

  return '' + str.substr(0, 1).toUpperCase() + str.substr(1);
}

export { ToCamelCase, TitleFromCamelCase, CapitalizeFirstLetter };



// WEBPACK FOOTER //
// ./src/app/filters/CamelCase.js